import { Client, fetchExchange, cacheExchange } from '@urql/core'

export async function getShopifyUrqlClient(): Promise<Client> {
  const shopifyGraphqlEndpoint = 'https://shop.artblocks.io/api/2024-04/graphql.json'

  const headers: { 'X-Shopify-Storefront-Access-Token': string } = {
    'X-Shopify-Storefront-Access-Token': '9a6a9f8ed248319f39c9c491f2361f55'
  }

  const shopifyClient = new Client({
    url: shopifyGraphqlEndpoint,
    exchanges: [fetchExchange, cacheExchange],
    fetchOptions: () => {
      return {
        headers
      }
    }
  })
  return shopifyClient
}
